import { colord } from 'colord';
export const DEFAULT_CATEGORY_COLORS = [
    { bg: '#2ECC71', text: '#FFFFFF' }, // Green - White text
    { bg: '#3498DB', text: '#FFFFFF' }, // Medium Blue - White text
    { bg: '#45B7D1', text: '#FFFFFF' }, // Blue - White text
    { bg: '#4ECDC4', text: '#000000' }, // Teal - Black text
    { bg: '#95A5A6', text: '#FFFFFF' }, // Gray - White text
    { bg: '#96CEB4', text: '#000000' }, // Mint - Black text
    { bg: '#98D8C8', text: '#000000' }, // Seafoam - Black text
    { bg: '#9B59B6', text: '#FFFFFF' }, // Purple - White text
    { bg: '#DDA0DD', text: '#000000' }, // Plum - Black text
    { bg: '#E67E22', text: '#FFFFFF' }, // Dark Orange - White text
    { bg: '#E74C3C', text: '#FFFFFF' }, // Dark Red - White text
    { bg: '#F1C40F', text: '#000000' }, // Bright Yellow - Black text
    { bg: '#F39C12', text: '#FFFFFF' }, // Orange - White text
    { bg: '#FF6B6B', text: '#FFFFFF' }, // Red - White text
    { bg: '#FFEAA7', text: '#000000' }, // Yellow - Black text
];
export const getRandomCategoryColor = () => {
    return DEFAULT_CATEGORY_COLORS[Math.floor(Math.random() * DEFAULT_CATEGORY_COLORS.length)];
};
export function hexToRgb(hex) {
    const cleaned = hex.replace('#', '');
    const num = parseInt(cleaned, 16);
    return {
        r: (num >> 16) & 255,
        g: (num >> 8) & 255,
        b: num & 255,
    };
}
export function getRelativeLuminance(hex) {
    const { r, g, b } = hexToRgb(hex);
    const [rs, gs, bs] = [r / 255, g / 255, b / 255].map((c) => c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4));
    return 0.2126 * rs + 0.7152 * gs + 0.0722 * bs;
}
export function hexToHsl(hex) {
    const { r, g, b } = hexToRgb(hex);
    const rn = r / 255;
    const gn = g / 255;
    const bn = b / 255;
    const max = Math.max(rn, gn, bn);
    const min = Math.min(rn, gn, bn);
    const l = (max + min) / 2;
    if (max === min)
        return { h: 0, s: 0, l };
    const d = max - min;
    const s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    let h = 0;
    if (max === rn)
        h = ((gn - bn) / d + (gn < bn ? 6 : 0)) / 6;
    else if (max === gn)
        h = ((bn - rn) / d + 2) / 6;
    else
        h = ((rn - gn) / d + 4) / 6;
    return { h, s, l };
}
export function hslToHex(h, s, l) {
    const hue2rgb = (p, q, t) => {
        if (t < 0)
            t += 1;
        if (t > 1)
            t -= 1;
        if (t < 1 / 6)
            return p + (q - p) * 6 * t;
        if (t < 1 / 2)
            return q;
        if (t < 2 / 3)
            return p + (q - p) * (2 / 3 - t) * 6;
        return p;
    };
    let r, g, b;
    if (s === 0) {
        r = g = b = l;
    }
    else {
        const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        const p = 2 * l - q;
        r = hue2rgb(p, q, h + 1 / 3);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 1 / 3);
    }
    const toHex = (c) => Math.round(c * 255)
        .toString(16)
        .padStart(2, '0');
    return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
}
/**
 * Returns a contrast-safe color for text/icons given a background-adjacent color.
 * Light colors get darkened; dark colors pass through unchanged.
 */
export function getContrastColor(hex) {
    const luminance = getRelativeLuminance(hex);
    if (luminance > 0.4) {
        const { h, s } = hexToHsl(hex);
        return hslToHex(h, s, 0.35);
    }
    return hex;
}
/**
 * Returns black or white text color for optimal readability on a given background.
 * Uses colord's isLight() which implements the YIQ formula for perceived brightness.
 */
export function getTextColorForBackground(bgHex) {
    if (!bgHex)
        return '#000000';
    return colord(bgHex).isLight() ? '#000000' : '#FFFFFF';
}
